function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from "react";
import Button from "../components/button";
import css from "./widget-error.module.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

class ErrorBoundary extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      error: null
    });

    _defineProperty(this, "tryAgain", () => {
      this.setState({
        error: null
      });
    });
  }

  static getDerivedStateFromError(error) {
    return {
      error
    };
  }

  componentDidCatch() {}

  render() {
    const {
      error
    } = this.state;
    return _jsxs(_Fragment, {
      children: [error !== null && _jsxs("div", {
        className: css.error,
        children: [_jsxs("div", {
          className: css.alert,
          children: [_jsx("div", {
            className: css.alertTitle,
            children: "Une erreur s'est produite !"
          }), _jsxs("div", {
            className: css.alertSubtitle,
            children: ["C'est embarrassant...", _jsx("span", {
              role: "img",
              "aria-label": "",
              children: "\uD83D\uDE14"
            })]
          }), _jsx(Button, {
            className: css.button,
            onClick: this.tryAgain,
            contained: true,
            children: "R\xE9essayer"
          })]
        }), _jsx("div", {
          className: css.report,
          children: _jsxs("div", {
            className: css.title,
            children: [_jsx("span", {
              className: css.prefix,
              children: "Erreur : "
            }), _jsx("span", {
              className: css.message,
              children: error.message
            })]
          })
        })]
      }), error === null && this.props.children]
    });
  }

}

export default ErrorBoundary;